import React from 'react';
import { Typography, Card, Empty, Button } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Placeholder: React.FC = () => {
  return (
    <div>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <Title level={2}>更多工具</Title>
        <Paragraph style={{ maxWidth: '800px', margin: '0 auto' }}>
          我们正在开发更多实用的在线工具，敬请期待！
        </Paragraph>
      </div>

      <Card>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="更多工具正在开发中"
          style={{ margin: '40px 0' }}
        >
          <Link to="/">
            <Button type="primary" icon={<HomeOutlined />}>
              返回首页
            </Button>
          </Link>
        </Empty>
      </Card>

      <div style={{ marginTop: '40px', textAlign: 'center' }}>
        <Paragraph>
          有什么工具需求？欢迎提供反馈和建议！
        </Paragraph>
      </div>
    </div>
  );
};

export default Placeholder;